<template>
  <Card :btnMsg="$t('cityForm.btn_text')" @changeStep="changeStep">
    <div class="card-cityForm">
      <div class="card-content">
        <div class="card-header">
          <div>
            <p class="card-title" v-html="$t('cityForm.title')"></p>
            <p class="card-text" v-html="$t('cityForm.text')"></p>
          </div>
          <img :src="writerPic" />
        </div>
        <a-form-model ref="cityForm" :model="formAddress" :rules="formRules">
          <div class="code-box">
            <a-form-model-item :label="$t('cityForm.form_city')" prop="city">
              <a-input :placeholder="$t('cityForm.form_city_placeholder')" v-model="formAddress.city" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('cityForm.form_state')" prop="region">
              <a-input :placeholder="$t('cityForm.form_state_placeholder')" v-model="formAddress.region" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('cityForm.form_postal_code')" prop="code">
              <a-input :placeholder="$t('cityForm.form_postal_code_placeholder')" v-model="formAddress.code" size="large" type="primary"></a-input>
            </a-form-model-item>
            <a-form-model-item :label="$t('cityForm.form_country')" prop="country">
              <a-input :placeholder="$t('cityForm.form_country_placeholder')" v-model="formAddress.country" size="large" type="primary"></a-input>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import { postSubmit } from '@/api/portal';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      formAddress: {},
      writerPic: require('@/assets/writer.png'),
      formRules: {
        city: [{ required: true, message: this.$t('cityForm.form_city_placeholder'), trigger: 'blur' }],
        region: [{ required: true, message: this.$t('cityForm.form_state_placeholder'), trigger: 'blur' }],
        code: [{ required: true, message: this.$t('cityForm.form_postal_code_placeholder'), trigger: 'blur' }],
        country: [{ required: true, message: this.$t('cityForm.form_country_placeholder'), trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    checkForm() {
      let bol = false;
      this.$refs.cityForm.validate(valid => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      return bol;
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        // this.$emit('input', { ...this.form, address: this.formAddress });
        postSubmit({ ...this.form, address: this.formAddress }).then(res => {
          this.$parent.changeStep('thanksAll',this.form);
        });
      }
    },
  },
};
</script>

<style lang="scss">
.card-cityForm {
  position: relative;
  width: 100%;
  .card-header {
    display: flex;
    gap: 12px;
    img {
      width: 154px;
      height: 154px;
      margin-top: -24px;
    }
  }
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .order-why-box {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .order-why {
      font-size: 14px;
      font-weight: 400;
      color: #676767;
    }
    .order-answer {
      font-size: 16px;
      font-weight: 500;
      color: #1a1a1a;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
